import React, { useState } from 'react';
import { connect } from 'react-redux';
import { selectEnlarged } from '../../shared/enlarged/';
import './gallery.scss';
import GalleryItem from '../../app/components/gallery/GalleryItem';

function ConnectViewGallery({
    data = [],
    enlargedList = [],
    captionList = [],
    isDraggable = true,
    selectEnlarged
}) {
    const [activeIndex, setActiveIndex] = useState(null);

    const onImageSelected = (localIndex) => {
        if (localIndex !== activeIndex) return;
        setActiveIndex(null);
        const selectedHref = data[localIndex].href;
        const globalIndex = enlargedList.findIndex(href => href === selectedHref);
        if (globalIndex === -1) {
            console.warn("Could not find image in enlargedList:", selectedHref);
            return;
        }
        selectEnlarged({
            srcList: enlargedList,
            captionList: captionList,
            currSrcIndex: globalIndex,
            options: { maxHeight: 880 },
            isDraggable: isDraggable,
        });
    };

    return (
        <div className='gallery__images' onMouseLeave={() => setActiveIndex(null)}>
            {data.map((currImage, i) => (
                <GalleryItem
                    key={i}
                    i={i}
                    currImage={currImage}
                    onImageSelected={onImageSelected}
                    isActive={activeIndex === i}
                    onActivate={(idx) => setActiveIndex(idx)}
                    onDeactivate={() => setActiveIndex(null)}
                    onMouseLeave={() => setActiveIndex(null)}
                />
            ))}
        </div>
    );
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
    selectEnlarged: (data) => dispatch(selectEnlarged(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectViewGallery);
